<template>
  <div class="field-text">
    <template v-if="effectiveType === 'date'">
      {{ formatDate(value) }}
    </template>
    <template v-else-if="effectiveType === 'image'">
      <!-- Múltiples imágenes -->
      <div v-if="Array.isArray(value)" class="d-flex flex-wrap gap-1">
        <img
          v-for="(img, idx) in value"
          :key="idx"
          :src="img"
          :alt="label + ' ' + (idx + 1)"
          class="table-image"
        />
      </div>
      <!-- Imagen única -->
      <img v-else-if="value" :src="value" :alt="label" class="table-image" />
    </template>
    <template v-else-if="effectiveType === 'file'">
      <FileDisplay :value="value" />
    </template>
    <template v-else-if="effectiveType === 'boolean'">
      <span :class="value ? 'text-success' : 'text-danger'">
        {{ value ? "YES" : "NO" }}
      </span>
    </template>
    <template v-else>
      <!-- Si el valor es un array, mostrarlo uno debajo del otro -->
      <div v-if="Array.isArray(displayValue) && displayValue.length > 0" class="field-text-array">
        <div
          v-for="(item, index) in displayValue"
          :key="index"
          class="field-text-array-item"
          :style="{ marginBottom: index < displayValue.length - 1 ? '4px' : '0', display: 'block' }"
        >
          {{ item }}
        </div>
      </div>
      <span v-else :class="displayValue < 0 ? 'text-danger' : 'text-success'">
        {{ displayValue }}
      </span>
    </template>
  </div>
</template>

<script>
import FileDisplay from "@/components/gotrading/common/FileDisplay.vue";
import {
  getFieldTranslatableLocales,
  getTranslatedFieldValue,
  getTranslatedFieldValueFromItem,
  isFieldTranslatable,
} from "@/utils/fieldValueI18n";

export default {
  name: "FieldText",
  components: {
    FileDisplay,
  },
  props: {
    field: {
      type: Object,
      default: () => ({}),
    },
    value: {
      type: [String, Number, Date, Boolean, Array, Object],
    },
    item: {
      type: Object,
      default: null,
    },
    type: {
      type: String,
      default: null,
    },
    label: {
      type: String,
      default: "",
    },
  },
  computed: {
    effectiveType() {
      return this.type || this.field?.type || "text";
    },
    displayValue() {
      const loc =
        this.$i18n && this.$i18n.locale
          ? String(this.$i18n.locale).split("-")[0]
          : "es";
      if (isFieldTranslatable(this.field) && this.item && this.field.key) {
        return getTranslatedFieldValueFromItem(
          this.item,
          this.field.key,
          loc,
          getFieldTranslatableLocales(this.field)
        );
      }
      return getTranslatedFieldValue(
        this.value,
        loc,
        getFieldTranslatableLocales(this.field)
      );
    },
  },
  methods: {
    formatDate(date) {
      if (!date) return "";
      return new Date(date).toLocaleDateString("es-ES", {
        day: "2-digit",
        month: "2-digit",
        year: "numeric",
      });
    },
  },
};
</script>

<style scoped>
.table-image {
  max-width: 50px;
  max-height: 50px;
  object-fit: cover;
}
.field-text-array {
  display: block;
}
</style>
